<template>
  <div class="footer-info">
    <img
      width="192"
      height="36"
      src="/img/logo/logo.svg"
      alt="logo"
      class="footer-info__logo"
    />
    <FooterSocials class="footer-info__socials" />
    <div class="footer-info__togglers">
      <TogglerTheme>
        <UiText
          class="footer-info__theme-text"
          font="body-heading-4"
          color="form-label-text-color"
          text="Тема:"
        />
      </TogglerTheme>
      <FooterTogglerLanguage v-if="false" />
    </div>
  </div>
</template>

<script>
import FooterSocials from '@/components/App/AppFooter/FooterSocials'
import TogglerTheme from '@/components/Base/TogglerTheme'
import FooterTogglerLanguage from '@/components/App/AppFooter/FooterTogglerLanguage'

export default {
  name: 'FooterInfo',
  components: {
    FooterSocials,
    TogglerTheme,
    FooterTogglerLanguage,
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
